// ESM Dependencies
import { polyfill } from "./polyfill/polyfill";
import { NavItems } from "./components/nav-items/nav-items";
import { SVGInject } from "./components/svg-inject/svg-inject";
import { LazyLoadImages } from "./components/lazy-image/lazy-image";
import { Hamburger } from "./components/hamburger/hamburger";

import { TextField } from "../common/material/form/text-field";
import { PasswordField } from "../common/material/form/password-field";
import { SelectField } from "../common/material/form/select-field";

// CJS Dependencies
const AOS = require("aos");

/**
 * Main Application
 */
export class VadainDealerlogin {

    public static async bootstrap() {
        await polyfill();
        return new this();
    }

    constructor() {
        this.init()
            .then(() => {
                // tslint:disable-next-line:no-console
                console.log("VadainDealerlogin init success");
            })
            .catch((error) => {
                // tslint:disable-next-line:no-console
                console.error("VadainDealerlogin init error", error);
            });
    }

    private get textFieldElements() {
        return Array.from(document.querySelectorAll(TextField.SELECTOR));
    }

    private get passwordFieldElements() {
        return Array.from(document.querySelectorAll(PasswordField.SELECTOR));
    }

    private get selectFieldElements() {
        return Array.from(document.querySelectorAll(SelectField.SELECTOR));
    }

    private async init() {
        try {
            await LazyLoadImages.init();
            await Hamburger.init();

            AOS.init();
            NavItems.autoInit();
            SVGInject.autoInit();

            // Native Javascript
            await Promise.all([
                import("./javascript/select-box" as any),
                import("./javascript/filter-toggle" as any),
                import("./javascript/harmonica-expand" as any),
                import("./javascript/fabric" as any),
                import("./javascript/carousel" as any),
                import("./javascript/search-modal" as any),
                import("./javascript/input-length" as any),
                import("./javascript/polyfill-object-fit" as any),

            ]);

            this.textFieldElements.map((containerElement) =>
                new TextField(containerElement));

            this.passwordFieldElements.map((containerElement) =>
                new PasswordField(containerElement));

            this.selectFieldElements.map((containerElement) =>
                new SelectField(containerElement));

        } catch (error) {
            throw error;
        }
    }
}

VadainDealerlogin.bootstrap()
    .then((VDL) => {
        // tslint:disable-next-line:no-console
        console.debug("Bootstrap: Application successfully bootstrapped!",
            VDL);
    })
    .catch((error) => {
        // tslint:disable-next-line:no-console
        console.error("Bootstrap: Error while bootstrapping application!",
            error.stack);
    });



// WEBPACK FOOTER //
// ./web.ts